(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/shared/supporter/pages/overview/tabs/campaign', '');
}]);
})();